<template>
  <v-layout
    class="interaction-topper review-interaction-topper pa-2 mb-2"
    align-center
    justify-start
  >
    <v-flex xs4></v-flex>
    <v-flex xs4>
      <v-layout
        justify-center
        align-center
      >
        <span class="grey--text">
          {{convertedTimestamp}}
        </span>
      </v-layout>
    </v-flex>
    <v-flex xs4>
      <v-layout
        justify-end
        align-center
      >
        <v-icon
          v-if="(
            !localInteractionAttempt
            || !Object.keys(localInteractionAttempt).length
            || localInteractionAttempt.pointsEarned === null
          )"
          class="correct-incorrect-icon no-flex text-xs-center"
          :size="24"
          color="gray"
        >
          remove
        </v-icon>
        <v-icon
          v-else-if="localInteractionAttempt.pointsEarned === localInteractionAttempt.pointsAvailable && isCorrect"
          class="correct-incorrect-icon no-flex text-xs-center"
          :size="24"
          color="#4CAF50"
        >
          check_circle
        </v-icon>
        <v-icon
          v-else-if="this.hideCorrectAnswerAlways"
          class="correct-incorrect-icon no-flex text-xs-center"
          :size="24"
          color="gray"
        >
          check_circle
        </v-icon>
        <v-icon
          v-else
          class="correct-incorrect-icon incorrect rotate-45deg no-flex text-xs-center"
          :size="24"
          color="#F44336"
        >
          add_circle
        </v-icon>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import Interaction from '../../mixins/Interaction';

export default {
  name: 'ReviewTopper',
  mixins: [
    Interaction,
  ],
  computed: {
    convertedTimestamp() {
      if (
        !this.$_.isFinite(this.localInteraction.displayOutTime)
        || this.localInteraction.displayOutTime === this.localInteraction.displayInTime
      ) {
        return this.localInteraction.displayInTime.toHoursMinutesSeconds();
      }
      return `${this.localInteraction.displayInTime.toHoursMinutesSeconds()} - ${this.localInteraction.displayOutTime.toHousMinutesSeconds()}`;
    },
    hideCorrectAnswerAlways() {
      return (
        !!this.$_.get(this, 'localInteraction.config.hide_correct_answer_always', false)
        && this.userType === 'student'
      );
    },
    isCorrect() {
      if (this.localInteractionAttempt.pointsAvailable === 0) {
        if (this.interaction.interactionType === 'multiple_choice') {
          const correctAnswer = this.interaction.interactionOptions.find((interaction) => interaction.correct === 1);
          return correctAnswer && correctAnswer.option === this.localInteractionAttempt.responseText;
        } else if (this.interaction.interactionType === 'check_all_apply') {
          const correctOptions = this.interaction.interactionOptions.filter((option) => option.correct === 1).map((choice) => choice.option);
          const selections = this.localInteractionAttempt.responseText.split(',');
          return selections.length === correctOptions.length && selections.every((selection) => correctOptions.includes(selection));
        } else if (this.interaction.interactionType === 'short_answer') {
          if (this.interaction.interactionOptions.length === 1) {
            const correctAnswers = this.interaction.interactionOptions[0].option.split(', ');
            return correctAnswers.includes(this.localInteractionAttempt.responseText);
          }
          const responses = this.localInteractionAttempt.responseText.split(',');
          const correctAnswers = this.interaction.interactionOptions.map((option) => option.option.split(', '));
          return correctAnswers.every((answers, index) => {
            const lowercase = answers.map((answer) => answer.toLowerCase());
            return lowercase.includes(responses[index].toLowerCase());
          });
        }
      }
      return true;
    },
  },
};
</script>
